import { HeaderButtonProps } from "@omni/types/components/props/headerButton.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";
import { ReactElement } from "react";

import { HeaderButtonComponent } from "@/components/Navigation/Buttons/HeaderButton/headerButton.component";

type Props = HeaderButtonProps<BaseStore.Etna> & {
    children?: ReactElement<{ closeCallback?: () => void }> | false | null;
};

export const HeaderButton = ({
    icon,
    text,
    innerHTML,
    alerts,
    ariaLabel,
    hover,
    invert,
    invertMobile,
    link,
    textHidden,
    children
}: Props) => {
    const menuElement =
        children ||
        (innerHTML !== "" && innerHTML !== undefined && (
            <div
                dangerouslySetInnerHTML={{
                    __html: innerHTML
                }}
            />
        ));

    return (
        <HeaderButtonComponent
            icon={icon}
            text={text}
            alerts={alerts}
            ariaLabel={ariaLabel}
            hover={hover}
            invert={invert}
            link={link}
            textHidden={textHidden}
            invertMobile={invertMobile}
        >
            {menuElement}
        </HeaderButtonComponent>
    );
};
